
import {Component, Prop, Vue} from "vue-property-decorator";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {stringify} from "@/auxillary/datafield.stringify";
import Hints from "@/components/study/datafields/base/Hints.vue";

@Component({
  name: 'TextField',
  components: {
    DataFieldBar,
    Hints
  },
})
export default class TextField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";

  get labelField() {
    return this.displayName.length <= 50 ? this.displayName : ""
  }

  get labelAbove() {
    return this.displayName.length > 50 ? this.displayName : ""
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }

  get counter() {
    return this.field.definition.maxLength ?? 200
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return !this.field.isEditable;
  }

  get isRequired() {
    return this.dataField.isRequired;
  }

  get value() {
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  set value(value: string) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  stringifyValue() {
    return stringify(this.field)
  }

  updateValue() {
    let value = "";
    if (this.unknown && this.canBeUnknown)
      value = "unknown";
    this.value = value;
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  set unknown(value: boolean) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "unknown", value})
    this.updateValue()
  }

  get field() {
    return this.dataField;
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }


}
